import React from 'react';
export function EditorTextBoldIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 3a1 1 0 00-1 1v16a1 1 0 001 1h6.5a5.5 5.5 0 002.883-10.184l.104-.089c.47-.41.85-.905 1.112-1.46.263-.555.401-1.156.401-1.767s-.138-1.212-.4-1.767a4.51 4.51 0 00-1.113-1.46 5.078 5.078 0 00-1.615-.947A5.5 5.5 0 0013 3H7zm6.5 9a3.5 3.5 0 110 7H8v-7h5.5zm-.498-2H8V5h5a3.5 3.5 0 011.19.207c.374.135.706.331.98.57.274.24.482.517.622.811.139.294.208.604.208.912 0 .308-.07.618-.208.912a2.51 2.51 0 01-.622.81 3.08 3.08 0 01-.98.571 3.5 3.5 0 01-1.188.207z"
  }));
}